import React, { useRef, useLayoutEffect, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import LogoImg from '../assets/logo.svg';
import Icon1 from '../assets/icon1.svg';
import Icon2 from '../assets/icon2.svg';
import Icon3 from '../assets/icon3.svg';
import Icon4 from '../assets/icon4.svg';
import Ca1 from '../assets/roblox.png';
import Ca2 from '../assets/joker_games.png';
import Ca3 from '../assets/joker_casino.png';

gsap.registerPlugin(ScrollTrigger);

const Content = styled.div`
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-bottom: 10%;
  overflow: hidden;
  @media (max-width: 900px) {
    overflow: hidden;
    padding-bottom: 18%;
  }
`;

const Title = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: -1.5%;
  @media (max-width: 760px) {
    height: auto;
    font-size: 5rem;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
  }
`;

const TitleMini = styled.p`
  font-size: 4rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin-top: 17rem;
  @media (max-width: 760px) {
    margin-top: 5rem;
    font-size: 3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #ddd;
  font-family: 'PoppinsMedium';
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 10px;
  margin-bottom: 2rem;
`;

const IconRow2 = styled.div`
  position: relative;
  width: 100%;
  height: 220px;
  margin-top: 3rem;
  margin-bottom: 2rem;
`;

const IconCard = styled.img`
  width: 320px;
  height: 420px;
  object-fit: contain;
  position: absolute;
  top: 0;
  cursor: pointer;
  transition: transform 0.3s ease;

  /* left card */
  &:nth-child(1) {
    left: 25%;
    transform: translateX(-20px) rotate(-10deg);
    transform-origin: right center;
    z-index: 1;
    
    &:hover {
      transform: translateX(-20px) rotate(-10deg) scale(1.1) !important;
      z-index: 10;
    }
  }

  /* center card (static) */
  &:nth-child(2) {
    left: 50%;
    transform: translateX(-50%) translateY(-5%) rotate(0deg);
    transform-origin: center bottom;
    z-index: 3;

    &:hover {
      transform: translateX(-50%) translateY(-5%) rotate(0deg) scale(1.1) !important;
      z-index: 10;
    }
  }

  /* right card */
  &:nth-child(3) {
    left: 51%;
    transform: translateX(20px) rotate(12deg);
    transform-origin: left center;
    z-index: 1;

    &:hover {
      transform: translateX(20px) rotate(12deg) scale(1.1) !important;
      z-index: 10;
    }
  }

  @media (min-width: 1500px) {
    &:nth-child(1) {
      left: 31%;
      transform: translateX(-20px) rotate(-10deg);
      transform-origin: right center;
      z-index: 1;
    }
  
    /* center card (static) */
    &:nth-child(2) {
      left: 50%;
      transform: translateX(-50%) translateY(-5%) rotate(0deg);
      transform-origin: center bottom;
      z-index: 3;
    }
  
    /* right card */
    &:nth-child(3) {
      left: 51%;
      transform: translateX(20px) rotate(12deg);
      transform-origin: left center;
      z-index: 1;
    }
  }

  @media only screen
  and (min-device-width: 900px)
  and (max-device-width: 1100px) {
    &:nth-child(1) {
      left: 15%;
      transform: translateX(-20px) rotate(-10deg);
      transform-origin: right center;
      z-index: 1;
    }
  
    /* center card (static) */
    &:nth-child(2) {
      left: 50%;
      transform: translateX(-50%) translateY(-5%) rotate(0deg);
      transform-origin: center bottom;
      z-index: 3;
    }
  
    /* right card */
    &:nth-child(3) {
      left: 51%;
      transform: translateX(20px) rotate(12deg);
      transform-origin: left center;
      z-index: 1;
    }
  }

  @media only screen
  and (min-device-width: 760px)
  and (max-device-width: 900px) {
    &:nth-child(1) {
      left: 5%;
      transform: translateX(-20px) rotate(-10deg);
      transform-origin: right center;
      z-index: 1;
    }
  
    /* center card (static) */
    &:nth-child(2) {
      left: 50%;
      transform: translateX(-50%) translateY(-5%) rotate(0deg);
      transform-origin: center bottom;
      z-index: 3;
    }
  
    /* right card */
    &:nth-child(3) {
      left: 51%;
      transform: translateX(20px) rotate(12deg);
      transform-origin: left center;
      z-index: 1;
    }
  }

  @media (max-width: 760px) {
    width: 140px;
    height: 250px;
    &:nth-child(1) {
      left: 7%;
      transform: translateX(-20px) rotate(-10deg);
    }
    &:nth-child(2) {
      left: 50%;
      transform: translateX(-50%) translateY(-5%) rotate(0deg);
      top: -10%;
    }
    &:nth-child(3) {
      left: 53%;
      transform: translateX(20px) rotate(12deg);
    }
  }

  @media (max-width: 414px) {
    width: 140px;
    height: 250px;
    &:nth-child(1) {
      left: 8%;
      transform: translateX(-20px) rotate(-10deg);
    }
    &:nth-child(2) {
      left: 49%;
      transform: translateX(-50%) translateY(-5%) rotate(0deg);
      top: -10%;
    }
    &:nth-child(3) {
      left: 49%;
      transform: translateX(20px) rotate(12deg);
    }
  }
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;

const DiscoverButton = styled.button`
  background: #fff;
  border: 1px solid #333;
  border-radius: 20px;
  padding: 0.5rem 1rem;
  font-size: 1.5rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration:none;
  margin-top: -2%;
  font-family: 'MongoGrotesqueLight';
  transition: background-color 0.2s, color 0.2s;
  color:black;
`;

const Game: React.FC = () => {
  const stackRef = useRef<HTMLDivElement>(null);
  const leftRef = useRef<HTMLImageElement>(null);
  const rightRef = useRef<HTMLImageElement>(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useLayoutEffect(() => {
    if (!stackRef.current || !leftRef.current || !rightRef.current) return;

    const offset = isMobile ? 50 : 100;
    const startPosition = isMobile ? 'top 80%' : 'top 60%';

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: stackRef.current,
        start: startPosition,
        once: true,
      }
    });

    tl.to(leftRef.current, {
      x: -offset,
      duration: 1,
      ease: 'power4.out',
    })
    .to(rightRef.current, {
      x:  offset,
      duration: 1,
      ease: 'power4.out',
    }, '<');

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, [isMobile]);

  const handleCardClick = (url: string | null) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <Content>
      <IconRow>
        <Icon src={Icon2} alt="Icon 2" />
        <Icon src={Icon3} alt="Icon 3" />
        <Icon src={Icon1} alt="Icon 1" />
        <Icon src={Icon4} alt="Icon 4" />
      </IconRow>

      <Title>ENTREZ DANS LE JEU</Title>

      <Subtitle>
        Entre mini-jeux, défis et classements...
        <br />
        C'est dans le jeu que les légendes prennent vie.
      </Subtitle>

      <IconRow2 ref={stackRef}>
        <IconCard 
          ref={leftRef} 
          src={Ca1} 
          alt="Carte 1" 
          onClick={() => handleCardClick(null)} // Joker Casino - pas encore de lien
        />
        <IconCard 
          src={Ca2} 
          alt="Carte 2" 
          onClick={() => handleCardClick('https://jokerclub.club/fr')} // Joker Games
        />
        <IconCard 
          ref={rightRef} 
          src={Ca3} 
          alt="Carte 3" 
          onClick={() => handleCardClick('https://www.roblox.com/games/16206908734/NEW-Joker-Sword-Fight')} // Joker Roblox
        />
      </IconRow2>

      <TitleMini>
        PEU IMPORTE LA PLATEFORME, ON TE MET À L'ÉPREUVE.
        <br />
        CHAQUE JEU RÉVÈLE TON VRAI NIVEAU. PRÊT·E À JOUER ?
      </TitleMini>

      <DiscoverButton>C'EST PARTI</DiscoverButton>
    </Content>
  );
};

export default Game;